import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { USER_INFO } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { UserInfoActionTypes } from './types';
import api from 'src/utils/api';

export const loadUserInfo =
  (
    id: number | string,
  ): ThunkAction<Promise<void>, State, null, UserInfoActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: USER_INFO + REQUEST });
    try {
      const payload = await api.loadUserInfo(id);
      dispatch({ type: USER_INFO + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: USER_INFO + FAILURE, error });
    }
  };

export const allListSurveyIdle = () => ({ type: USER_INFO + IDLE });
